import React from "react";
// creates a beautiful scrollbar
// import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";

 import routes from "configs/dashboardRoutes";

import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";
import { NotifyProvider } from "@Components/Notify";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/reactlogo.png";
import { SIDEBAR_COLOR } from "theme/colors";
import PropTypes from "prop-types";
import { STORAGE_CONSTANT } from "../configs/constants";

// let ps;

const useStyles = makeStyles(styles);

const Admin = ({ children, ...rest }) => {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  // eslint-disable-next-line no-unused-vars
  const [image, setImage] = React.useState(bgImage);
  // eslint-disable-next-line no-unused-vars
  const [color, setColor] = React.useState(SIDEBAR_COLOR.themeColor);
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    // if (navigator.platform.indexOf("Win") > -1) {
    //   ps = new PerfectScrollbar(mainPanel.current, {
    //     suppressScrollX: true,
    //     suppressScrollY: false,
    //   });
    //   document.body.style.overflow = "hidden";
    // }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      // if (navigator.platform.indexOf("Win") > -1) {
      //   ps.destroy();
      // }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);



let accessRoutes = JSON.parse(localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES))



if (!Array.isArray(accessRoutes)) {
  accessRoutes = [];
}

// Create an array of names in accessRoutes for easier checking
const accessRouteNames = accessRoutes.map(route => route.name);

// Iterate through the routes
routes.forEach(route => {
  // Check if the route has an 'items' array
  if (route.items && Array.isArray(route.items)) {
    // Find the index of the item with name 'Attendance Record'
    const attendanceItemIndex = route.items.findIndex(item => item.name === "Attendance Record");

    // Check if the "Attendance report by month" sub-item exists in "Attendance Record"
   /*  const attendanceReportByMonthExists = 
      attendanceItemIndex !== -1 && 
      route.items[attendanceItemIndex].subItems &&
      route.items[attendanceItemIndex].subItems.some(subItem => subItem.name === "Attendance report by month")  */

       const attendanceReportByMonthExists = 
      attendanceItemIndex !== -1 && 
      route.items[attendanceItemIndex].subItems &&
      route.items[attendanceItemIndex].subItems.some(subItem => 
          subItem.name === "Attendance Record by month" || subItem.name === "Attendance Record by month" || 
          subItem.name === "Attendance Record"
      ); 

    // Remove the item if it exists and both "Attendance Record" and "Attendance Report by Month" are not in accessRouteNames
    if (
      attendanceItemIndex !== -1 && 
      !accessRouteNames.includes("Attendance Record") && 
      !accessRouteNames.includes("Attendance Report by Month") &&
      // !accessRouteNames.includes("Attendance Record by Month") &&
      !attendanceReportByMonthExists // Only remove if sub-item is not found
    ) {
      route.items.splice(attendanceItemIndex, 1);
    }
  }
});


  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"FGV"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and container classes are present because they have some paddings which would make the map smaller */}
        <NotifyProvider>
          <div className={classes.content}>
            <div className={classes.container}>{children}</div>
          </div>
        </NotifyProvider>
      </div>
    </div>
  );
};

Admin.propTypes = {
  children: PropTypes.element,
};

export default Admin;
